module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"imprint":"Impressum","tos":"AGB","privacy":"Datenschutz"},"en":{"imprint":"Imprint","tos":"Terms of Service","privacy":"Privacy Policy"}}')
  delete Component.options._Ctor
}
